import React, { Component, Fragment } from "react";
import { translate } from "react-polyglot";
import {
  Col,
  FormGroup,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  Table
} from "reactstrap";
import * as yup from "yup";
import { Buildup, GeneratePdfComponent } from "../../generated/graphql";
import isRevitClient from "../../helpers/isRevitClient";
import { createBuildup } from "../../helpers/revitClient";
import GeneratePDFButton from "../buildup/GeneratePDFButton";
import ViewBuildupParameters from "../buildup/ViewBuildupParameters";
import CustomButton from "../helpers/CustomButton";
import MetsecModal from "../MetsecModal";
import ViewLayers from "./ViewLayers";

interface IProps {
  hideModal: () => void;
  buildup: any;
}

interface IBuildupWithTypename extends Buildup {
  __typename: string;
}

class ViewBuildupModal extends Component<IProps & TranslateProps> {
  public state = {
    isOpen: true
  };

  public validationSchema = yup.object().shape({
    description: yup.string().required(),
    name: yup.string().required()
  });

  public render() {
    const { hideModal, buildup } = this.props;

    return (
      <MetsecModal size="lg" isOpen={this.state.isOpen} toggle={hideModal}>
        {this.renderData(buildup)}
      </MetsecModal>
    );
  }

  private renderData(buildup: IBuildupWithTypename) {
    const { hideModal, t } = this.props;
    const {
      __typename: _,
      template: { id: templateId },
      id,
      name,
      description,
      layers,
      isArchived: __,
      ...buildupFields
    } = buildup;

    const buildupParameters = Object.entries(buildupFields)
      .filter(([key, value]) => value)
      .map(([key, value], index) => {
        const paramName = t(`parameters.${key}`);

        return (
          <tr key={`buildupParameter-${index}`}>
            <td>{paramName}</td>
            <td>{value}</td>
          </tr>
        );
      });

    return (
      <Fragment>
        <ModalHeader toggle={hideModal}>{t("labels.viewBuildups")}</ModalHeader>
        <ModalBody>
          <Row>
            <Col>
              <ViewBuildupParameters templateId={templateId} />
            </Col>
            <Col>
              <FormGroup>
                <label>{t("labels.name")}</label>
                <h3>{name}</h3>
              </FormGroup>
              <FormGroup>
                <label>{t("parameters.description")}:</label>
                <h3>{description}</h3>
              </FormGroup>
            </Col>
          </Row>
          <Table
            className="table-flush"
            responsive={true}
            hover={true}
            striped={true}
          >
            <thead className="thead-light">
              <tr>
                <th>{t("parameters.parameter")}</th>
                <th>{t("parameters.value")}</th>
              </tr>
            </thead>
            <tbody>{buildupParameters}</tbody>
          </Table>
        </ModalBody>
        <ModalFooter>
          <GeneratePDFButton buildupId={buildup.id} />
          {isRevitClient() && (
            <CustomButton
              color="primary"
              onClick={() => createBuildup(JSON.stringify(buildup))}
            >
              {t("labels.createBuildup")}
            </CustomButton>
          )}
        </ModalFooter>
      </Fragment>
    );
  }
}

export default translate()(ViewBuildupModal);
